import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productVariantsTitle: {
    description: 'products.productVariantsTitle',
    defaultMessage: 'Variants',
    id: '55l8VS',
  },
  productVariantsSku: {
    description: 'products.productVariantsSku',
    defaultMessage: 'SKU',
    id: 'TACrjC',
  },
  productVariantsName: {
    description: 'products.productVariantsName',
    defaultMessage: 'Name',
    id: '2L2Rgs',
  },
  productVariantsActive: {
    description: 'products.productVariantsActive',
    defaultMessage: 'Active',
    id: 'fNJMgY',
  },
  productVariantsActions: {
    description: 'products.productVariantsActions',
    defaultMessage: 'Actions',
    id: 'BsFiQY',
  },
  productVariantsActionsLink: {
    description: 'products.productVariantsActionsLink',
    defaultMessage: 'Promote to Standalone',
    id: 'XSU91C',
  },
  productAddVariant: {
    description: 'products.productAddVariant',
    defaultMessage: 'Add Variant',
    id: 'MfzAWM',
  },
  productDetailsSaveInPlaceMessage: {
    description: 'Message for saving product details in order to add Variants',
    defaultMessage: 'This product must be saved before adding variants.',
    id: 'LY1PJr',
  },
  productDetailsSaveInPlaceButton: {
    description: 'Button to save product details in order to add Variants',
    defaultMessage: 'Save Product Now & Continue Editing',
    id: 'ayV9QI',
  },
  variantWarningConfirm: {
    description: 'Variant modal confirm',
    defaultMessage: 'Confirm',
    id: 'wYrEkm',
  },
  variantWarningCancel: {
    description: 'Add variant warning modal cancel',
    defaultMessage: 'Cancel',
    id: '6ea6cP',
  },
  addVariantWarningBody: {
    description: 'Add variant warning modal body',
    defaultMessage:
      "This product already exists as another parent's variant. Are you sure you want to make this product a variant for this parent instead?",
    id: 'N0mRmm',
  },
  removeVariantWarningBody: {
    description: 'Remove variant modal body',
    defaultMessage: 'Are you sure you want to remove this product variant?',
    id: 'p2FfzL',
  },
  upsellDescription: {
    defaultMessage:
      'Upgrade your plan to Gold or higher or select the add-on to create product bundles to sell multiple products together.',
    id: 'aeekhU',
    description: 'Informs the user which plan they must upgrade to in order to enable Kits and Bundles features.',
  },
  upgradeToStandardOrPremiumDescription: {
    defaultMessage: 'Upgrade to Standard or Premium to access product bundles and sell multiple products together.',
    id: 'HK2Hkt',
    description: 'Description for good/better/best plan profile users explaining plan requirement for bundles.',
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: 'wzFBvu',
    description: 'Call to action button to upgrade plan for good/better/best plan profile users.',
  },
});
